<template>
    <div>
        <h2 class="text-h6 mt-9 mb-1">
            <strong>Send During Hours ({{send_during_timezone}})</strong>
        </h2>

        <rc-text-expand-button
            :expanded="schedule_expanded"
            @click="schedule_expanded = !schedule_expanded"
        >
            {{ schedule_summary }}
        </rc-text-expand-button>

        <div v-show="schedule_expanded" class="mt-3">
            <m-daily-schedule
                :value="template.send_during"
                :read_only="read_only"
                @input="onInput"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        send_during_timezone: {
            type: String,
            default: ''
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            schedule_expanded: false
        }
    },

    computed: {
        schedule_summary() {
            const schedule = this.template.send_during;
            
            if (!schedule) return 'Click to configure schedule';

            if (schedule.custom_intervals && schedule.custom_intervals.length > 0) {
                return 'Custom schedule configured (click to view details)';
            }

            const days = [
                schedule.monday_intervals,
                schedule.tuesday_intervals,
                schedule.wednesday_intervals,
                schedule.thursday_intervals,
                schedule.friday_intervals,
                schedule.saturday_intervals,
                schedule.sunday_intervals
            ];

            const all_same = days.every((dayIntervals, index) => {
                if (index === 0) return true;
                return JSON.stringify(dayIntervals) === JSON.stringify(days[0]);
            });

            if (all_same && days[0]) {
                if (days[0].length === 0) {
                    return 'No hours configured';
                } else if (days[0].length === 1) {
                    return `${days[0][0]} daily`;
                } else {
                    return `${days[0].join(', ')} daily`;
                }
            } else {
                return 'Varies by day (click to view details)';
            }
        }
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    }
}
</script>
